export interface PracticeTypeRates {
  mentalHealth?: [number, number];
  primaryCare?: [number, number];
  medicalAesthetics?: [number, number];
  ivInfusion?: [number, number];
  multiService?: [number, number];
  hormoneOptimization?: [number, number];
  urgentCare?: [number, number];
}

export interface StateData {
  code: string;
  name: string;
  npcMedian: number;
  npcP25: number;
  npcP75: number;
  singleAimRate: number;
  mdOwnedAvg: number;
  mdSetupFee: number;
  sampleSize: string;
  practiceTypes?: PracticeTypeRates;
}

export const statesData: Record<string, StateData> = {
  FL: {
    code: "FL",
    name: "Florida",
    npcMedian: 499,
    npcP25: 449,
    npcP75: 599,
    singleAimRate: 775,
    mdOwnedAvg: 890,
    mdSetupFee: 625,
    sampleSize: "150+",
    practiceTypes: {
      mentalHealth: [474, 549],
      primaryCare: [424, 499],
      medicalAesthetics: [549, 699],
      ivInfusion: [424, 599],
      multiService: [599, 774]
    }
  },
  TX: {
    code: "TX",
    name: "Texas",
    npcMedian: 549,
    npcP25: 499,
    npcP75: 749,
    singleAimRate: 775,
    mdOwnedAvg: 920,
    mdSetupFee: 625,
    sampleSize: "125+",
    practiceTypes: {
      mentalHealth: [499, 649],
      primaryCare: [424, 549],
      medicalAesthetics: [549, 699],
      hormoneOptimization: [499, 649],
      multiService: [649, 899]
    }
  },
  CA: {
    code: "CA",
    name: "California",
    npcMedian: 649,
    npcP25: 499,
    npcP75: 699,
    singleAimRate: 942,
    mdOwnedAvg: 950,
    mdSetupFee: 625,
    sampleSize: "85+",
    practiceTypes: {
      mentalHealth: [599, 699],
      primaryCare: [599, 699],
      medicalAesthetics: [649, 849],
      hormoneOptimization: [649, 749],
      multiService: [699, 1099]
    }
  },
  OH: {
    code: "OH",
    name: "Ohio",
    npcMedian: 524,
    npcP25: 449,
    npcP75: 599,
    singleAimRate: 775,
    mdOwnedAvg: 900,
    mdSetupFee: 625,
    sampleSize: "75+",
    practiceTypes: {
      mentalHealth: [449, 599],
      primaryCare: [424, 549],
      medicalAesthetics: [424, 599],
      urgentCare: [424, 549],
      multiService: [549, 749]
    }
  },
  PA: {
    code: "PA",
    name: "Pennsylvania",
    npcMedian: 499,
    npcP25: 449,
    npcP75: 674,
    singleAimRate: 775,
    mdOwnedAvg: 890,
    mdSetupFee: 625,
    sampleSize: "65+",
    practiceTypes: {
      mentalHealth: [449, 624],
      primaryCare: [449, 499],
      medicalAesthetics: [449, 773],
      ivInfusion: [449, 599],
      multiService: [574, 773]
    }
  },
  NC: {
    code: "NC",
    name: "North Carolina",
    npcMedian: 599,
    npcP25: 549,
    npcP75: 649,
    singleAimRate: 775,
    mdOwnedAvg: 900,
    mdSetupFee: 625,
    sampleSize: "45+"
  },
  GA: {
    code: "GA",
    name: "Georgia",
    npcMedian: 599,
    npcP25: 574,
    npcP75: 649,
    singleAimRate: 775,
    mdOwnedAvg: 900,
    mdSetupFee: 625,
    sampleSize: "35+"
  },
  MI: {
    code: "MI",
    name: "Michigan",
    npcMedian: 474,
    npcP25: 450,
    npcP75: 499,
    singleAimRate: 775,
    mdOwnedAvg: 900,
    mdSetupFee: 625,
    sampleSize: "30+"
  },
  VA: {
    code: "VA",
    name: "Virginia",
    npcMedian: 524,
    npcP25: 499,
    npcP75: 549,
    singleAimRate: 775,
    mdOwnedAvg: 900,
    mdSetupFee: 625,
    sampleSize: "40+"
  },
  NY: {
    code: "NY",
    name: "New York",
    npcMedian: 499,
    npcP25: 449,
    npcP75: 599,
    singleAimRate: 775,
    mdOwnedAvg: 900,
    mdSetupFee: 625,
    sampleSize: "35+"
  },
  TN: {
    code: "TN",
    name: "Tennessee",
    npcMedian: 549,
    npcP25: 499,
    npcP75: 649,
    singleAimRate: 775,
    mdOwnedAvg: 900,
    mdSetupFee: 625,
    sampleSize: "30+"
  },
  AZ: {
    code: "AZ",
    name: "Arizona",
    npcMedian: 524,
    npcP25: 474,
    npcP75: 599,
    singleAimRate: 775,
    mdOwnedAvg: 900,
    mdSetupFee: 625,
    sampleSize: "25+"
  },
  IL: {
    code: "IL",
    name: "Illinois",
    npcMedian: 549,
    npcP25: 499,
    npcP75: 649,
    singleAimRate: 775,
    mdOwnedAvg: 920,
    mdSetupFee: 625,
    sampleSize: "35+"
  },
  NJ: {
    code: "NJ",
    name: "New Jersey",
    npcMedian: 549,
    npcP25: 499,
    npcP75: 649,
    singleAimRate: 775,
    mdOwnedAvg: 920,
    mdSetupFee: 625,
    sampleSize: "25+"
  },
  CO: {
    code: "CO",
    name: "Colorado",
    npcMedian: 524,
    npcP25: 474,
    npcP75: 599,
    singleAimRate: 775,
    mdOwnedAvg: 900,
    mdSetupFee: 625,
    sampleSize: "20+"
  },
  WA: {
    code: "WA",
    name: "Washington",
    npcMedian: 599,
    npcP25: 549,
    npcP75: 699,
    singleAimRate: 775,
    mdOwnedAvg: 920,
    mdSetupFee: 625,
    sampleSize: "20+"
  },
  MD: {
    code: "MD",
    name: "Maryland",
    npcMedian: 549,
    npcP25: 499,
    npcP75: 624,
    singleAimRate: 775,
    mdOwnedAvg: 900,
    mdSetupFee: 625,
    sampleSize: "25+"
  },
  SC: {
    code: "SC",
    name: "South Carolina",
    npcMedian: 524,
    npcP25: 474,
    npcP75: 599,
    singleAimRate: 775,
    mdOwnedAvg: 890,
    mdSetupFee: 625,
    sampleSize: "20+"
  },
  IN: {
    code: "IN",
    name: "Indiana",
    npcMedian: 474,
    npcP25: 424,
    npcP75: 549,
    singleAimRate: 775,
    mdOwnedAvg: 880,
    mdSetupFee: 625,
    sampleSize: "20+"
  },
  AL: {
    code: "AL",
    name: "Alabama",
    npcMedian: 499,
    npcP25: 449,
    npcP75: 574,
    singleAimRate: 775,
    mdOwnedAvg: 880,
    mdSetupFee: 625,
    sampleSize: "15+"
  },
  MS: {
    code: "MS",
    name: "Mississippi",
    npcMedian: 499,
    npcP25: 449,
    npcP75: 574,
    singleAimRate: 775,
    mdOwnedAvg: 870,
    mdSetupFee: 625,
    sampleSize: "10+"
  },
  AK: { code: "AK", name: "Alaska", npcMedian: 524, npcP25: 449, npcP75: 649, singleAimRate: 775, mdOwnedAvg: 900, mdSetupFee: 625, sampleSize: "5+" },
  AR: { code: "AR", name: "Arkansas", npcMedian: 524, npcP25: 449, npcP75: 649, singleAimRate: 775, mdOwnedAvg: 900, mdSetupFee: 625, sampleSize: "5+" },
  CT: { code: "CT", name: "Connecticut", npcMedian: 524, npcP25: 449, npcP75: 649, singleAimRate: 775, mdOwnedAvg: 900, mdSetupFee: 625, sampleSize: "5+" },
  DE: { code: "DE", name: "Delaware", npcMedian: 524, npcP25: 449, npcP75: 649, singleAimRate: 775, mdOwnedAvg: 900, mdSetupFee: 625, sampleSize: "5+" },
  HI: { code: "HI", name: "Hawaii", npcMedian: 524, npcP25: 449, npcP75: 649, singleAimRate: 775, mdOwnedAvg: 900, mdSetupFee: 625, sampleSize: "5+" },
  IA: { code: "IA", name: "Iowa", npcMedian: 524, npcP25: 449, npcP75: 649, singleAimRate: 775, mdOwnedAvg: 900, mdSetupFee: 625, sampleSize: "5+" },
  ID: { code: "ID", name: "Idaho", npcMedian: 524, npcP25: 449, npcP75: 649, singleAimRate: 775, mdOwnedAvg: 900, mdSetupFee: 625, sampleSize: "5+" },
  KS: { code: "KS", name: "Kansas", npcMedian: 524, npcP25: 449, npcP75: 649, singleAimRate: 775, mdOwnedAvg: 900, mdSetupFee: 625, sampleSize: "5+" },
  KY: { code: "KY", name: "Kentucky", npcMedian: 524, npcP25: 449, npcP75: 649, singleAimRate: 775, mdOwnedAvg: 900, mdSetupFee: 625, sampleSize: "5+" },
  LA: { code: "LA", name: "Louisiana", npcMedian: 524, npcP25: 449, npcP75: 649, singleAimRate: 775, mdOwnedAvg: 900, mdSetupFee: 625, sampleSize: "5+" },
  MA: { code: "MA", name: "Massachusetts", npcMedian: 524, npcP25: 449, npcP75: 649, singleAimRate: 775, mdOwnedAvg: 900, mdSetupFee: 625, sampleSize: "5+" },
  ME: { code: "ME", name: "Maine", npcMedian: 524, npcP25: 449, npcP75: 649, singleAimRate: 775, mdOwnedAvg: 900, mdSetupFee: 625, sampleSize: "5+" },
  MN: { code: "MN", name: "Minnesota", npcMedian: 524, npcP25: 449, npcP75: 649, singleAimRate: 775, mdOwnedAvg: 900, mdSetupFee: 625, sampleSize: "5+" },
  MO: { code: "MO", name: "Missouri", npcMedian: 524, npcP25: 449, npcP75: 649, singleAimRate: 775, mdOwnedAvg: 900, mdSetupFee: 625, sampleSize: "5+" },
  MT: { code: "MT", name: "Montana", npcMedian: 524, npcP25: 449, npcP75: 649, singleAimRate: 775, mdOwnedAvg: 900, mdSetupFee: 625, sampleSize: "5+" },
  NE: { code: "NE", name: "Nebraska", npcMedian: 524, npcP25: 449, npcP75: 649, singleAimRate: 775, mdOwnedAvg: 900, mdSetupFee: 625, sampleSize: "5+" },
  NV: { code: "NV", name: "Nevada", npcMedian: 524, npcP25: 449, npcP75: 649, singleAimRate: 775, mdOwnedAvg: 900, mdSetupFee: 625, sampleSize: "5+" },
  NH: { code: "NH", name: "New Hampshire", npcMedian: 524, npcP25: 449, npcP75: 649, singleAimRate: 775, mdOwnedAvg: 900, mdSetupFee: 625, sampleSize: "5+" },
  NM: { code: "NM", name: "New Mexico", npcMedian: 524, npcP25: 449, npcP75: 649, singleAimRate: 775, mdOwnedAvg: 900, mdSetupFee: 625, sampleSize: "5+" },
  ND: { code: "ND", name: "North Dakota", npcMedian: 524, npcP25: 449, npcP75: 649, singleAimRate: 775, mdOwnedAvg: 900, mdSetupFee: 625, sampleSize: "5+" },
  OK: { code: "OK", name: "Oklahoma", npcMedian: 524, npcP25: 449, npcP75: 649, singleAimRate: 775, mdOwnedAvg: 900, mdSetupFee: 625, sampleSize: "5+" },
  OR: { code: "OR", name: "Oregon", npcMedian: 524, npcP25: 449, npcP75: 649, singleAimRate: 775, mdOwnedAvg: 900, mdSetupFee: 625, sampleSize: "5+" },
  RI: { code: "RI", name: "Rhode Island", npcMedian: 524, npcP25: 449, npcP75: 649, singleAimRate: 775, mdOwnedAvg: 900, mdSetupFee: 625, sampleSize: "5+" },
  SD: { code: "SD", name: "South Dakota", npcMedian: 524, npcP25: 449, npcP75: 649, singleAimRate: 775, mdOwnedAvg: 900, mdSetupFee: 625, sampleSize: "5+" },
  UT: { code: "UT", name: "Utah", npcMedian: 524, npcP25: 449, npcP75: 649, singleAimRate: 775, mdOwnedAvg: 900, mdSetupFee: 625, sampleSize: "5+" },
  VT: { code: "VT", name: "Vermont", npcMedian: 524, npcP25: 449, npcP75: 649, singleAimRate: 775, mdOwnedAvg: 900, mdSetupFee: 625, sampleSize: "5+" },
  WI: { code: "WI", name: "Wisconsin", npcMedian: 524, npcP25: 449, npcP75: 649, singleAimRate: 775, mdOwnedAvg: 900, mdSetupFee: 625, sampleSize: "5+" },
  WV: { code: "WV", name: "West Virginia", npcMedian: 524, npcP25: 449, npcP75: 649, singleAimRate: 775, mdOwnedAvg: 900, mdSetupFee: 625, sampleSize: "5+" },
  WY: { code: "WY", name: "Wyoming", npcMedian: 524, npcP25: 449, npcP75: 649, singleAimRate: 775, mdOwnedAvg: 900, mdSetupFee: 625, sampleSize: "5+" }
};

export const nationalDefaults: StateData = {
  code: "US",
  name: "National Average",
  npcMedian: 524,
  npcP25: 449,
  npcP75: 649,
  singleAimRate: 775,
  mdOwnedAvg: 900,
  mdSetupFee: 625,
  sampleSize: "600+"
};

// Popular states shown first in selector
export const popularStates = ["FL", "TX", "CA", "OH", "PA", "NC", "GA", "NY"];

// Get state by code or return national defaults
export const getStateData = (code: string): StateData => {
  return statesData[code] || nationalDefaults;
};

// Get all available states as array
export const getAllStates = (): StateData[] => {
  return Object.values(statesData);
};
